<div class="call-back">
  <h2>Checking Login Details</h2>
  <div class="call-back__container">
    <div *comSpinner="!errorLoadingData; color: 'primary'; diameter: 35"></div>
    @if (errorLoadingData) {
      <div class="call-back__update-message">
        <p>
          There was a problem logging into the application.
          <button mat-raised-button class="call-back__buttons call-back__buttons--try-again" (click)="tryAgain()">
            Try Again ({{ tryAgainTimeRemaining }})
          </button>
        </p>
      </div>
    }
    @if (userDataNotLoaded) {
      <div class="call-back__update-message">
        <p>Please wait, something is taking longer than usual.</p>
      </div>
    }
  </div>
</div>
